module.exports = __webpack_public_path__ + "static/media/reachedTop100_90_120.d53fbe8a.png";